import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SavingAgreementNotes } from "@app/models/saving-agreement-notes";
import { SavingAgreementNotesService } from "@app/services/saving-agreement-notes.service";

@Component({
    selector: "app-saving-agreement-note-node",
    templateUrl: "./saving-agreement-note-node.component.html",
    styleUrls: ["./saving-agreement-note-node.component.css"],
    standalone: false
})
export class SavingAgreementNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() savingAgreementNotes: Array<SavingAgreementNotes>;
  @Input() selectedSavingAgreementNotes: Array<SavingAgreementNotes>;
  @Output() onAddSavingAgreementNote = new EventEmitter<SavingAgreementNotes>();
  @Output() onDeleteSavingAgreementNote = new EventEmitter<SavingAgreementNotes>();

  constructor(private savingAgreementNotesService: SavingAgreementNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addSavingAgreementNote(item);
    } else {
      this.deleteSavingAgreementNote(item);
    }
  }

  addSavingAgreementNote(item) {
    this.onAddSavingAgreementNote.emit(item);
  }

  deleteSavingAgreementNote(item) {
    this.onDeleteSavingAgreementNote.emit(item);
  }

  isSelectedSavingAgreementNote(item) {
    var parents = [];
    for (var i = 0; i < this.selectedSavingAgreementNotes.length; i++) {
      var selectedSavingNote = this.savingAgreementNotesService.findSavingAgreementNoteById(this.selectedSavingAgreementNotes[i].id, this.savingAgreementNotes);
      var parents = parents.concat(this.savingAgreementNotesService.findSavingAgreementNoteParents(selectedSavingNote, this.savingAgreementNotes));
    }
    var sParents = new Set(parents.map(p=>p.id));
    return sParents.has(item.id);
  }

}
